import React from 'react';
import { Container } from './styles';

const BlockedCourseCard = () => {
  return (
    <Container>
      <div className="card p-4">
        <div className="card-body">
          <p className="text-center">
            Você precisa adquirir o curso <strong>Introdução ao Mundo das Licitações</strong> para
            poder ver essa aula.
          </p>
          <a href="/planos" className="btn btn-primary w-100">
            Quero adquirir o curso
          </a>
        </div>
      </div>
    </Container>
  );
};

export default BlockedCourseCard;
